import React, { PureComponent } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Icon,
  Input,
  MenuItem,
  Select,
  Slide
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { injectIntl } from 'react-intl';
import { isEmail, isNullOrEmpty } from '../../../../../../utils/utils';

const EMPTY_CONTACT = {
  placeholder: true,
  contactPersonName: 'EMPTY'
};

const EMPTY_PRODUCT = {
  placeholder: true,
  newEasyCareProduct: 'EMPTY'
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class DialogSignatureRequired extends PureComponent {
  constructor(props) {
    super(props);

    const foundIndex = this.getContactOptions().findIndex(
      (contact) =>
        contact.contactPersonName === props.data.renewal.customerApproverName
    );

    const listItems = props.data.renewal.lineItems;
    const newEasyCareProducts = listItems.map(listItem => listItem.itemName);

    const selectedContactIndex = foundIndex > 0 ? foundIndex : 0;

    this.state = {
      selectedContactIndex,
      isProposed: props.data.customer?.workflowTicket?.proposed
    };

    this.onSelectChange = this.onSelectChange.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.getContactOptions = this.getContactOptions.bind(this);
    this.getProductOptions = this.getProductOptions.bind(this);
  }

  getContactOptions() {
    return [EMPTY_CONTACT, ...this.props.data.customer.customerContacts];
  }

  getProductOptions() {
    const listItems = this.props.data.renewal.lineItems;
    const newEasyCareProductList = listItems.map(listItem => listItem.itemName);
    return [EMPTY_PRODUCT, ...newEasyCareProductList];
  }

  onSelectChange(selectedContactIndex) {
    this.setState(
      {
        selectedContactIndex
      },
      () => {
        const contact =
          this.getContactOptions()[this.state.selectedContactIndex];
        const updatedRenewal = contact.placeholder
          ? {
              ...cloneDeep(this.props.data.renewal),
              customerApproverName: '',
              customerEmail: ''
            }
          : {
              ...cloneDeep(this.props.data.renewal),
              customerApproverName: contact.contactPersonName,
              customerEmail: contact.contactPersonEmail
            };
        this.props.data.updateRenewal(updatedRenewal, false);
      }
    );
  }

  onChangeName(customerApproverName) {
    this.props.data.updateRenewal(
      {
        ...this.props.data.renewal,
        customerApproverName
      },
      false
    );
  }

  onChangeEmail(customerEmail) {
    this.props.data.updateRenewal(
      {
        ...this.props.data.renewal,
        customerEmail
      },
      false
    );
  }

  onBlur() {
    this.props.data.updateRenewal(this.props.data.renewal, false);
  }

  render() {
    const lineItems = this.props.data.renewal.lineItems;
    const newEasyCareItems = lineItems.filter(i => i.newImageCare === true).flatMap(({
                                                                                       itemName,
                                                                                       newImageCare,
                                                                                       itemCode,
                                                                                       size
                                                                                     }) => {
      return [{
        itemName: itemName,
        newImageCare: newImageCare,
        itemCode: itemCode,
        size: size
      }
      ]
    })
    const list = [];
    var productInfo = '';
    for (let i in newEasyCareItems) {
      if(newEasyCareItems[i].newImageCare === true){
        productInfo = newEasyCareItems[i].itemName + '                  ' + newEasyCareItems[i].itemCode + '              ' + newEasyCareItems[i].size;
        list.push(productInfo);
      }
    }
    const hasValidEmail =
      !isNullOrEmpty(this.props.data.renewal.customerEmail) &&
      isEmail(this.props.data.renewal.customerEmail);
    let onAcceptButtonLabel = 'send_to_customer';
    if (this.state.isProposed)
      onAcceptButtonLabel = hasValidEmail
        ? 'resend_to_customer'
        : 'update_contact';

    return (
      <Dialog
        aria-labelledby="signature-required-title"
        aria-describedby="signature-required-description"
        open={this.props.open}
        onClose={this.props.onClose}
        TransitionComponent={Transition}
        className="dialog-wrapper"
      >
        {list.length > 0 &&
          <DialogTitle id="signature-required-title" className="dialog-title">
            {this.props.intl.formatMessage({
              id: 'easy_care_conversion'
            })}
          </DialogTitle>}

        {list.length > 0 &&
          <DialogContent style={{ minHeight: '20vh',
            maxHeight: '20vh'}}>
            <div>
              <p style={{ textJustify: "inter-word" }}>During the renewal based on company standards, the below products have either been converted from our legacy Inventory Maintenance to EasyCare, or have been enrolled in EasyCare:</p><br />
              {list.map(filteredName => (
                <li>
                  {filteredName}
                </li>
              ))}
            </div>
          </DialogContent>}

        <DialogTitle id="signature-required-title" className="dialog-title">
          {this.props.intl.formatMessage({
            id: 'customer_signature_required'
          })}
        </DialogTitle>
        <DialogContent>
          <p id="signature-required-description" className="dialog-text">
            {this.props.intl.formatMessage({
              id: !this.state.isProposed
                ? 'confirm_service_agreement'
                : 'resend_confirm_service_agreement'
            })}
          </p>
          {!this.state.isProposed ? (
            <FormControl className="approval-contact expand-field-width">
              <label
                className="dialog-subheader"
                htmlFor="approval-contact-select"
              >
                {this.props.intl.formatMessage({
                  id: 'approval_contact'
                })}
              </label>
              <Select
                value={this.state.selectedContactIndex}
                onChange={(event) => this.onSelectChange(event.target.value)}
                inputProps={{
                  name: 'approval-contact',
                  id: 'approval-contact-select'
                }}
              >
                {this.getContactOptions().map((contact, index) => (
                  <MenuItem key={index} value={index}>
                    {contact.contactPersonName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : null}
          <FormControl className="text-input-field expand-field-width">
            <label className="dialog-subheader" htmlFor="contact-name-field">
              {this.props.intl.formatMessage({
                id: 'contact_first_and_last_name'
              })}
            </label>
            <Input
              id="contact-name-field"
              value={this.props.data.renewal.customerApproverName || ''}
              onChange={(event) => this.onChangeName(event.target.value)}
              onBlur={this.onBlur}
            />
          </FormControl>
          <FormControl className="text-input-field expand-field-width">
            <label className="dialog-subheader" htmlFor="contact-email-field">
              {this.props.intl.formatMessage({
                id: 'contact_email'
              })}
            </label>
            <Input
              id="contact-email-field"
              value={this.props.data.renewal.customerEmail || ''}
              onChange={(event) => this.onChangeEmail(event.target.value)}
              onBlur={this.onBlur}
            />
          </FormControl>
        </DialogContent>
        <DialogActions className="dialog-action-buttons">
          <span className="btn-secondary-action">
            <Button onClick={() => this.props.onClose(true)} color="primary">
              {this.props.intl.formatMessage({
                id: 'cancel'
              })}
            </Button>
          </span>
          <span className="btn-action">
            <Button
              onClick={this.props.onAccept}
              color="primary"
              disabled={
                isNullOrEmpty(this.props.data.renewal.customerApproverName) ||
                (!isNullOrEmpty(this.props.data.renewal.customerEmail) &&
                  !isEmail(this.props.data.renewal.customerEmail))
              }
            >
              {this.props.intl.formatMessage({
                id: onAcceptButtonLabel
              })}
              <Icon>chevron_right</Icon>
            </Button>
          </span>
        </DialogActions>
      </Dialog>
    );
  }
}

DialogSignatureRequired.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func,
  data: PropTypes.object
};

export default injectIntl(DialogSignatureRequired);
